/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  export class MeevoSwitch implements angular.IDirective {
    restrict = "E";
    require = "ngModel";
    scope = {
        ngModel: "=ngModel",
        contentKey: "@",
        disabled: "=ngDisabled"
    };

    template = "<md-switch id=\"{{ contentKey }}switch{{ $parent.$index }}\" ng-model=\"ngModel\" ng-disabled=\"disabled\"></md-switch><label class=\"meevo-switch-label\" translate=\"{{::contentKey}}\"></label>"

    static factory(): angular.IDirectiveFactory {
      let directive = () => {
        return new MeevoSwitch();
      };

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoSwitch", MeevoSwitch.factory());
}